export class InvoiceDetailI18n {
    public static NullValue = '----';
    public static BannerHeader = 'Invoice Detail';
    public static InvoiceNumber = 'Invoice #';
    public static InvoiceDate = 'Invoice Date';
    public static DueDate = 'Due Date';
    public static PurchaseDate = 'Purchase Date';
    public static Terms = 'Terms';
    public static DaysPastDue = 'Days Past Due';
    public static DaysPastDueToolTip = 'Number of days since the invoice due date.';
    public static Age = 'Age';
    public static AgeToolTip = 'Number of days since the invoice date.';
    public static BalanceDue = 'Balance Due';
    public static BalanceDueToolTip = 'Total balance outstanding from your customer.';
    public static PartialPayment = 'Partial Payment';
    public static PartialPaymentToolTip =
        'Payments received from your customer for less than the full amount owed.';
    public static LastPaymentDate = 'Last Payment Date';
    public static TimelineComingSoon = 'Timeline coming soon...';
    public static Days = ' Days';
}
